import { z } from "zod";
import {
  callEndToolPatchPayloadSchema,
  callEndToolPostPayloadSchema,
  callEndToolSettingsSchema,
  CallEndToolType
} from "./tools/callEnd.js";
import {
  callTransferToolPatchPayloadSchema,
  callTransferToolPostPayloadSchema,
  callTransferToolSettingsSchema,
  CallTransferToolType
} from "./tools/callTransfer.js";
import {
  customToolPatchPayloadSchema,
  customToolPostPayloadSchema,
  customToolSettingsSchema,
  CustomToolType
} from "./tools/custom.js";
const ToolType = {
  CALL_TRANSFER: CallTransferToolType,
  CALL_END: CallEndToolType,
  CUSTOM: CustomToolType
};
const allToolTypes = [
  ToolType.CALL_TRANSFER,
  ToolType.CALL_END,
  ToolType.CUSTOM
];
function checkIsToolType(value) {
  return allToolTypes.some((toolType) => value === toolType);
}
const allToolSettingsSchemas = {
  [ToolType.CALL_TRANSFER]: callTransferToolSettingsSchema,
  [ToolType.CALL_END]: callEndToolSettingsSchema,
  [ToolType.CUSTOM]: customToolSettingsSchema
};
function safeParseToolSettings(type, data) {
  return allToolSettingsSchemas[type].safeParse(data);
}
const toolPostPayloadSchema = z.discriminatedUnion("type", [
  callTransferToolPostPayloadSchema,
  callEndToolPostPayloadSchema,
  customToolPostPayloadSchema
]);
const toolPatchPayloadSchema = z.discriminatedUnion("type", [
  callTransferToolPatchPayloadSchema,
  callEndToolPatchPayloadSchema,
  customToolPatchPayloadSchema
]);
function getCustomToolMock(tool) {
  if (tool.type !== ToolType.CUSTOM) {
    return void 0;
  }
  return tool.settings.mock;
}
export {
  ToolType,
  checkIsToolType,
  getCustomToolMock,
  safeParseToolSettings,
  toolPatchPayloadSchema,
  toolPostPayloadSchema
};
//# sourceMappingURL=tool.js.map
